import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TProjectTypeTag } from '@/console/features/projects/components/project-type-tag/project-type-tag.types';
import { Tag } from '@/shared/components/ui/tag/tag';
import { ProjectTypeEnum } from '@/shared/types/types.generated';

export const ProjectTypeTag: React.FC<TProjectTypeTag> = ({ project }) => {
  const { t } = useTranslation();

  if (project.projectType === ProjectTypeEnum.Standard) {
    return null;
  }

  return (
    <Tag
      label={
        <Typography variant="p9" color="primary">
          {t(
            `projects:form.fields.project_type.${project.projectType.toLowerCase()}`,
          )}
        </Typography>
      }
    />
  );
};
